import { Controller } from "stimulus"

export default class extends Controller {
  static values = { expiresAt: Number }
  static targets = ["timer"]

  connect() {
    this.tick()
    this.interval = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    if (this.interval) clearInterval(this.interval)
  }

  tick() {
    const remaining = Math.max(0, Math.floor((this.expiresAtValue * 1000 - Date.now()) / 1000))
    const m = String(Math.floor(remaining / 60)).padStart(2, "0")
    const s = String(remaining % 60).padStart(2, "0")
    this.timerTarget.textContent = `${m}:${s}`
    if (remaining === 0) {
      if (this.interval) clearInterval(this.interval)
      window.location.reload()
    }
  }
}
